import React from 'react';
import Icon from 'components/AppIcon';


const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-gray-900 text-white rounded-2xl shadow-xl px-4 py-3 flex items-center gap-3 flex-wrap justify-center">
      <span className="text-sm font-caption font-medium">
        {selectedCount} usuario{selectedCount !== 1 ? 's' : ''} seleccionado{selectedCount !== 1 ? 's' : ''}
      </span>
      <div className="w-px h-5 bg-gray-600" />
      <button
        onClick={() => onBulkAction('activate')}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-caption transition-colors"
      >
        <Icon name="CheckCircle" size={13} color="white" />
        Activar
      </button>
      <button
        onClick={() => onBulkAction('suspend')}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-600 hover:bg-red-500 text-white text-xs font-caption transition-colors"
      >
        <Icon name="UserX" size={13} color="white" />
        Suspender
      </button>
      <button
        onClick={() => onBulkAction('export')}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gray-700 hover:bg-gray-600 text-white text-xs font-caption transition-colors"
      >
        <Icon name="Download" size={13} color="white" />
        Exportar
      </button>
      <button
        onClick={onClearSelection}
        className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-gray-700 transition-colors"
        aria-label="Cancelar selección"
      >
        <Icon name="X" size={14} color="white" />
      </button>
    </div>
  );
};

export default BulkActionsBar;